<template>
  <div class="viewer" v-if="dialogVisible">
    <div class="inner">
      <div class="close" @click="handleClose">
        <i class="el-icon-close"></i>
      </div>
      <table>
        <tr>
          <td><img class="img" src="@/static/images/endexam.png" /></td>
          <td>
            <div class="boxer">
              <div class="title">您已完成本试卷的模拟作答</div>
              <div class="info">如果您对作答结果不满意，可以选择继续作答</div>
              <div class="bottom-btns">
                <a class="btn" @click="viewReport">查看报告</a>
                <a class="btn" @click="enterExam">继续作答</a>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  props: ['dialogVisible', 'guid', 'url'],
  methods: {
    handleClose(done) {
      this.$emit('onCancel')
    },
    viewReport() {
      window.open(
        'https://cdnw2.acmcoder.com/release/exam/2.1.3/htmls/result/index.html?code=' +
          this.guid
      )
      this.handleClose()
    },
    enterExam() {
      this.$emit('goExam')
    },
  },
}
</script>
<style lang="scss" scoped>
.viewer {
  position: fixed;
  background: rgba(0, 0, 0, 0.6);
  display: grid;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 999;
  .inner {
    margin: auto;
    position: relative;
    width: 700px;
    padding: 0px 30px;
    background: #e1f0c0;
    border-radius: 6px;
    border: 4px solid #aaa;
    .img {
      width: 180px;
      margin: 30px;
    }
    .close {
      position: absolute;
      top: 5px;
      right: 10px;
      font-size: 30px;
      color: #999;
      font-weight: bold;
      cursor: pointer;
    }
    .boxer {
      font-size: 16px;
      text-align: left;
      color: #333;
      .title {
        font-size: 30px;
        margin-bottom: 20px;
        color: #6ea028;
      }
      .info {
        padding: 20px 0px;
      }
    }
    .bottom-btns .btn {
      background: #29bdb9;
      margin-right: 10px;
      &:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/practice/answered/index.vue